(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/pages/home/page.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/pages/home/page.js');
"use strict";


const {
  PageWrapper
} = svs.ticketsValidateManual.components;
const {
  Info,
  InfoMobile,
  PhysicalInfo,
  DividedCodeInput,
  InstructionsInfo,
  TrackQRCodeFailure
} = svs.ticketsValidateManual.pages.home.components;
const {
  QrScanner
} = svs.tur.qrScanner;
const validateQrCode = url => {
  const {
    matchPath
  } = ReactRouterDOM;
  const qrUrl = new URL(url);
  const match = matchPath(qrUrl === null || qrUrl === void 0 ? void 0 : qrUrl.pathname, {
    path: '/rl/:ticketId'
  });
  if (!match) {
    throw new Error('Invalid QR code');
  }
  svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(match.params.ticketId);
};
const Page = _ref => {
  let {
    match
  } = _ref;
  const [showQrScanner, setShowQrScanner] = React.useState(false);
  const isMobile = svs.core.detect.formfactor.mobile();
  if (showQrScanner) {
    return React.createElement(QrScanner, {
      onClose: () => setShowQrScanner(false),
      validateQrCode: validateQrCode
    });
  }
  return React.createElement(PageWrapper, null, React.createElement(TrackQRCodeFailure, {
    ticketId: match.params.ticketId
  }), isMobile ? React.createElement(InfoMobile, {
    onScanQrClick: () => setShowQrScanner(true)
  }) : React.createElement(Info, null), React.createElement(DividedCodeInput, {
    ticketId: match.params.ticketId
  }), React.createElement(PhysicalInfo, null), React.createElement(InstructionsInfo, null));
};
setGlobal('svs.ticketsValidateManual.pages.Home', Page);

 })(window);